import './VerifyEmailApp.less';
import React, {useState, useEffect} from 'react';
import BeforeLoginTemplate from "../../templates/before-login/BeforeLoginTemplate";
import __ from "../../i18n";
import Button from "../../../bootstrap/components/button/Button";
import {TOAST_ERROR} from "../../../bootstrap/scomponents/toasts/Toasts";
import AuthSendVerificationEmailParcel from "../../api/endpoints/auth/AuthSendVerificationEmailParcel";
import Toasts from "../../../bootstrap/scomponents/toasts/Toasts";
import Request from "../../../bootstrap/api/Request";
import Icon from "../../../bootstrap/components/icon/Icon";


export default function VerifyEmailApp() {

    const [seconds, setSeconds] = useState(0);

    const [resent, setResent] = useState(0);

    let interval;

    const restartCountDown = () => {
        setSeconds(30);

        interval = setInterval(() => {
            setSeconds(seconds => {
                if (seconds > 0) {
                    return seconds - 1;
                }

                clearInterval(interval);
                return 0;
            });
        }, 1000);
    };

    const resendEmail = () => {
        setResent(1);

        Request.add(new AuthSendVerificationEmailParcel())
            .then(data => {
                setResent(0);
                restartCountDown();
            })
            .catch(error => {
                setResent(0);
                Toasts.add(TOAST_ERROR, error.getMessage());
            });

    };

    return <div className="verify-email-app">
        <BeforeLoginTemplate>
            <div className="icon-block">
                <Icon name="info-circle"/>
            </div>
            <div className="app-title">{__('Verify your email')}</div>
            <div className="guidelines">{__('verify_email_description')}</div>
            <div className="action-block">
                <Button
                    appearance={resent === 1 ? 'text-primary' : 'solid-primary'}
                    onClick={resent !== 1 ? () => resendEmail() : undefined}
                    title={resent === 1 ? __('Email sending...') : __('Resend email')}
                    disabled={seconds > 0}
                />
                {
                    seconds > 0 &&
                    <div className="count-down">{__('Retry in 0[:]::seconds', {seconds: (seconds < 10 ? '0' : '') + seconds})}</div>
                }
            </div>
        </BeforeLoginTemplate>
    </div>;
}
